import { DynamicImageLoader } from './DynamicImageLoader';
import imageConfigEnv from './imageConfigEnv';
import imagesHostname from '@spa/lib/configs/imagesHostname';
import { default as nextDefaultLoader } from 'next/dist/shared/lib/image-loader';
import publicBaseUrl from '@spa/lib/configs/publicBaseUrl';

const nextJsLoader: DynamicImageLoader = (props, config = imageConfigEnv) => {
  const src: string = props.src;

  let result: string | undefined = undefined;

  let url: string | undefined;

  const isLocalUrl = src.startsWith('/');
  const isRemoteUrl = src.startsWith('https://') || src.startsWith('http://');

  if (isLocalUrl || isRemoteUrl) {
    if (imagesHostname === null || isRemoteUrl) {
      url = src;
    } else {
      url = `${publicBaseUrl}${src}`;
    }

    const loaderResult = nextDefaultLoader({
      config,
      ...props,
      src: url
    });
    if (loaderResult !== undefined) {
      result = imagesHostname === null ? loaderResult : `${imagesHostname}${loaderResult}`;
    }
  }

  return result;
};

export default nextJsLoader;
